import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GlobalContext } from '@thd-olt-global/global-provider-component';

const defaultOpts = {
  smooth: true
};
function withPageChange(WrappedComponent, opts = defaultOpts) {
  const wrapped = class extends Component {
    static contextType = GlobalContext;

    componentDidMount() {
      const { history: { action } = {} } = this.props;// eslint-disable-line
      if (action === 'PUSH') {
        window.requestAnimationFrame(() => {
          if (opts.smooth) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } else {
            window.scrollTo(0, 0);
          }
        });
      }
      this.makeStickyHeader();
    }

    componentWillUnmount() {
      this.removeStickyHeader();
    }

    makeStickyHeader = () => {
      const { request = {} } = this.context;
      const { channel = 'desktop' } = request;

      const { location = {} } = this.props;
      const { pathname = '' } = location;
      const isBrowseSearchPage = /\/(s|b)\//.test(pathname);
      const isProductEntryPage = /\/(pep)\//.test(pathname);

      if (channel === 'mobile' && (isBrowseSearchPage || isProductEntryPage)) {
        const el = document.querySelector('.Header3');
        if (el && el.className && el.className.indexOf('Header3-sticky') === -1) {
          el.className += ' Header3-sticky';
          this.setState({ headerIsRendered: true });
        }
      }
    };

    removeStickyHeader = () => {
      const { request = {} } = this.context;
      const { channel = 'desktop' } = request;

      const { location = {} } = this.props;
      const { pathname = '' } = location;
      const isBrowseSearchPage = /\/(s|b)\//.test(pathname);
      const isProductEntryPage = /\/(pep)\//.test(pathname);

      if (channel === 'mobile' && (isBrowseSearchPage || isProductEntryPage)) {
        const el = document.querySelector('.Header3');
        if (el && el.className) {
          el.className = el.className.replace(' Header3-sticky', '');
        }
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  wrapped.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string
    }).isRequired,
  };

  return React.memo(wrapped);
}

export default withPageChange;
